import { PropsWithChildren, forwardRef } from 'react'
import { Link, LinkProps } from 'react-router-dom'

import { usePrepareToProps } from './prepare-to-props'

const AppLink = forwardRef<HTMLAnchorElement, PropsWithChildren<LinkProps>>((props, ref) => (
  <Link ref={ref} {...props} to={usePrepareToProps(props.to)}>
    {props.children}
  </Link>
))

export default AppLink
